module.exports = __webpack_public_path__ + "static/zooty-logo-6647d6b82298fbc2792d76ae4c031ce2.svg";